module.exports = "<div style=\"display: block; margin: 24px; border: 1px solid #eee; padding: 24px;\" [innerHTML]=\"htmlPage\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/files/html-page/html-page.component.html
// module id = 1746
// module chunks = 0